<template>
  <section class='helpContent' id="helpMenu" :class="{'mobile': mobile}">
    <section class="helpContent__header">
      <div class="helpContent__header--iconLabel">
        <span class="icon-grey-arrowLeft" @click="goBack"></span>
        <span class="title bookFont"> {{messages.title}} </span>
        <span class="icon-grey-close close" v-if="mobile" @click="closeHelp"></span>
      </div>
    </section>
    <section class="helpContent__options">
      <transition-staggered
        tag="ul"
        className="helpContent__options--item"
        type="horizontally"
      >
        <li
          v-for="(item, index) in messages.options"
          :key="item.id"
          :data-index="index"
          @mouseover="subItems(index, 'hover')"
          @mouseleave="subItems(index, '')"
          @click="subItems(index, 'click')"
          :class="{'itemActive': showSubMenu === index && actived, 'itemActiveHover': showHoverMenu === index, 'lastIndex': index === 5}"
          class="listItem bookFont"
        >
          <span class="icon-grey-mail" v-if="index === 5" :class="{'itemActiveHover': showHoverMenu === index}"></span>
          {{ item.principalLabel }}
          <template v-if="showSubMenu === index">
            <transition-staggered
              tag="ul"
              className="faqEmail"
              type="vertically"
              v-if="item.FAQLabel"
            >
              <li class="faq bookFont" :data-index="0" :key="0" @click="getHelp(index, 'help')">
                <span class="icon-grey-help" :class="{'itemActive': showSubMenu === index}"></span>
                {{ item.FAQLabel }}
              </li>
              <li class="email bookFont" :data-index="1" :key="1" @click="getHelp(index, 'mail')">
                <span class="icon-grey-mail" :class="{'itemActive': showSubMenu === index}"></span>
                {{ item.email }}
              </li>
            </transition-staggered>
          </template>
        </li>
      </transition-staggered>
    </section>
  </section>
</template>

<script>
import messagesConfig from './messagesHelp.json'
import transitionStaggered from '../transitions/transitionStaggered'
import { reactive, ref } from 'vue'

export default {
  name: 'helpMenu',
  props: ['mobile'],
  components: {
    transitionStaggered
  },
  emits: ['close-help-menu', 'go-back'],
  setup (props, { emit }) {
    const messages = reactive(messagesConfig)
    const showSubMenu = ref('')
    const showHoverMenu = ref('')
    const actived = ref(null)

    /**
     * @description Launch emit to close menu
     */
    function closeHelp () {
      emit('close-help-menu')
    }

    /**
     * @description Redirect to help URL or open the email client
     * @param type help to open another tab or mail to open the email client
     */
    function getHelp (index, type) {
      switch (type) {
        case 'help':
          window.open(messages.options[index].FAQRedirect)
          break
        case 'mail':
          location.href = messages.options[index].emailRedirect
          break
      }
    }

    /**
     * @description Go back apps menu
     */
    function goBack () {
      emit('go-back', 'help')
    }

    /**
     * @description Show or hide, and execute over when the user click or hover
     * @param index Index item
     * @param type Action
     */
    function subItems (index, type) {
      switch (type) {
        case 'click':
          actived.value = true
          if (!messages.options[index].redirect) {
            showSubMenu.value = index
          } else {
            if (index === 4) {
              window.open(messages.options[index].redirect)
            } else {
              location.href = messages.options[index].redirect
            }
            showSubMenu.value = index
          }
          break
        case 'hover':
          showHoverMenu.value = index
          break
        default:
          showHoverMenu.value = ''
          break
      }
    }

    return {
      closeHelp,
      getHelp,
      goBack,
      subItems,
      messages,
      showSubMenu,
      showHoverMenu,
      actived
    }
  }
}
</script>
